<button (click)="checkOption(chip.name, chip.flag, i)" [ngClass]="chip.flag ? 'selected-multiselect-option': null" class="option-container" [disabled]="selected">
    <mat-checkbox [checked]="chip.flag" [disabled]="selected" [ngClass]="chip.flag ? 'selected-multiselect-option': null">
    </mat-checkbox>
    <span>{{chip.name}}</span>
</button>